import {SocialFormControl, SocialPlatformNames} from "../types/socialTypes";

export const socialFormFields: Record<SocialPlatformNames, SocialFormControl[]> = {
    [SocialPlatformNames.dailyMotion]: [
        {
            name: 'name',
            type: "text",
            label: "Account Name",
        },
        {
            name: 'account_id',
            type: "text",
            label: "Account ID",
        },
        {
            name: 'client_id',
            type: "text",
            label: "Client ID",
        },
        {
            name: 'token',
            type: "text",
            label: "Token",
            secret: true,
        },
    ],
    [SocialPlatformNames.instagram]: [
        {
            name: 'name',
            type: "text",
            label: "AccountName",
        }
    ],
    [SocialPlatformNames.facebook]: [
        {
            name: 'name',
            type: "text",
            label: "Account Name",
        }

    ],
    [SocialPlatformNames.youtube]: [
        {
            name: 'name',
            type: "text",
            label: "Account Name",
            visibleUpdate: true,
            visibleCreate: true,
        },
    ],
    [SocialPlatformNames.tiktok]: [
        {
            name: 'name',
            type: "text",
            label: "Account Name",
            visibleUpdate: true,
            visibleCreate: true,
        }
    ],
    [SocialPlatformNames.telegram]: []
}